import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicGreaterThan extends DesigntimeComponent {
    static staticName = "Logic: Greater than (fixed value)";
    static staticId = "logicGreaterThan";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            limit: { value: 10, dontTranslate: true }
        };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicGreaterThan'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key) {
            return;
        }

        var res = parseInt(eventParams.value) > this.values.limit.value;
        this.params.parameter1.value = res;
        this.eventBroker.fireValueChanged(this.id, "value", res);
        this.eventBroker.fireValueChanged(this.id, "not_value", !res);
    }

    output = [
        { name: "value", type: "bool" },
        { name: "not_value", type: "bool" }
    ];
}

export { LogicGreaterThan }
